import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { STATIC_ASSET_URL } from '../../utils/content-templates';

// TODO: need to add more definition to this
export interface StylePackProps {
	id: string;
}

export function getAssetURL(url: string) {
	return url.replace('ASSET_URL', STATIC_ASSET_URL);
}

export default function StylePackLoadingSkeleton(props: StylePackProps) {
	const {id} = props;

    return (
        <div className="style-pack"
            key={`style-pack-filter-${id}`}
        >
            <div
                className="style-pack-header"
                data-testid="style-pack-header"
            >
                <Skeleton width={80} height={23} style={{ marginRight: '255px' }}/>
                <Skeleton width={41.5} height={19} style={{ alignSelf: 'end' }} />
            </div>
            <div className="carousel">
			    <div className="carousel-track">
                    <div className="carousel-item">
						<Skeleton width={185} height={105} style={{
                            marginRight: '8px',
                            borderRadius: '8px',
                            top:'-1px'
                        }}/>
                    </div>
                    <div className="carousel-item">
						<Skeleton width={185} height={105} style={{
                            marginRight: '8px',
                            borderRadius: '8px',
                            top:'-1px'
                        }}/>
                    </div>
                    <div className="carousel-item">
						<Skeleton width={185} height={105} style={{
                            marginRight: '8px',
                            borderRadius: '8px',
                            top:'-1px'
                        }}/>
                    </div>
                    <div className="carousel-item">
						<Skeleton width={185} height={105} style={{
                            marginRight: '8px',
                            borderRadius: '8px',
                            top:'-1px'
                        }}/>
                    </div>
                </div>
            </div>
        </div>
    );
}
